import { Optional, Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  standalone: false,name: 'msjDescriptionPipe'})

export class MsjDescriptionPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private data: any;

    constructor( private http: HttpClient,
        @Optional() private readonly transloco?: TranslocoService) {
        this.load();
    }

    async load () {
        if (!this.data) {
            const result = await firstValueFrom(this.http.get('assets/error.json'));
            this.data = result;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: any): string {
        const translatedError = this.transloco?.translate('common.error');
        // Fallback por si las traducciones aún no se cargaron
        const response = translatedError && translatedError !== 'common.error' ? translatedError : 'Ocurrió un error, intente nuevamente.';
        let responseDescription;

        if (value) {
            responseDescription = value.description;
        }

        try {
            if (!this.data) {
                return response;
            }

            if (value.code || value.description) {
                // Si el error es 'Metadata Nro Legajo is requerid' lo cambio por NroLegajoRequerid
                if (value.code === 'Metadata Nro Legajo is requerid') {
                    value.code = 'NroLegajoRequerid';
                }

                if (value.code && value.code.startsWith('Metadata ') && value.code.endsWith('is required') ){
                    value.code = 'MetadataRequerid';
                }

                let code = value.code;
                if (value.code){
                    code = value.code.replaceAll(" ", "");
                }

                return this.data[code] || value.description || response;
            }

            if (value.message) {
                return this.data[value.message] || value.message || response;
            }

            return this.data[value as string] || response;
        } catch (_Exception) {      
            return responseDescription || response;
        }
    }
}
